import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import { SpaceliftVcsRepoCommitDetails } from "shared/SpaceliftVcsRepo/useGetSpaceliftVcsRepoCommit/gql";

type CommitDetailsDrawerProps = {
  commit: SpaceliftVcsRepoCommitDetails;
};

const CommitDetailsDrawer = createDrawer(({ commit }: CommitDetailsDrawerProps) => {
  const author = commit.authorEmail || commit.authorName;

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Commit details" />
        <DrawerCloseIcon />
      </DrawerHeader>

      <DrawerBody>
        <FormFieldViewText label="SHA" value={commit.sha} withCopy />
        <FormFieldViewText label="Message" value={commit.message} />
        {commit.description && <FormFieldViewText label="Description" value={commit.description} />}
        {author && <FormFieldViewText label="Author" value={author} />}
        <FormFieldTimestamp label="Committed at" timestamp={commit.createdAt} />
        <FormFieldViewText label="Files changed" value={String(commit.files.length)} />
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showCommitDetailsDrawer = createDrawerTrigger(CommitDetailsDrawer);
